// Homeowner add-on notes (Oct 2, 2026).
//
// Each homeowner-side add-on (upgrades / retail profit / at-cost retail) can
// carry two notes:
//   - description    → CUSTOMER-facing. Rendered on the signing page and the
//                      signed install-agreement PDF; part of agreement_data.
//   - internal_note  → STAFF only. Rendered for Chad (agreement + build
//                      approval), Robert (schedule build, PM board) and on the
//                      deal Overview. Stripped server-side from ho_resolve_deal
//                      and ho_sign_agreement — never reaches the homeowner.

export type AddOnKey = "upgrades" | "retail_profit" | "at_cost_retail";

export const ADD_ONS: Array<{ key: AddOnKey; label: string; customerLabel: string }> = [
  { key: "upgrades", label: "Upgrades", customerLabel: "Upgrades" },
  { key: "retail_profit", label: "Retail profit add-ons", customerLabel: "Additional work" },
  { key: "at_cost_retail", label: "@ cost retail", customerLabel: "Additional trades (at cost)" },
];

type AddOnSource = Partial<Record<
  | AddOnKey
  | `${AddOnKey}_description`
  | `${AddOnKey}_internal_note`,
  unknown
>>;

export interface AddOnLine {
  key: AddOnKey;
  label: string;
  customerLabel: string;
  amount: number;
  description: string;
  internalNote: string;
}

const str = (v: unknown) => (v == null ? "" : String(v).trim());

/** Every add-on that has an amount OR any note, in display order. */
export function addOnLines(d: AddOnSource): AddOnLine[] {
  return ADD_ONS.map((a) => ({
    key: a.key,
    label: a.label,
    customerLabel: a.customerLabel,
    amount: Number(d[a.key] ?? 0) || 0,
    description: str(d[`${a.key}_description`]),
    internalNote: str(d[`${a.key}_internal_note`]),
  })).filter((l) => l.amount > 0 || l.description || l.internalNote);
}

/** Columns a select needs for the add-on card. */
export const ADD_ON_COLS =
  "upgrades,retail_profit,at_cost_retail,upgrades_description,upgrades_internal_note,retail_profit_description,retail_profit_internal_note,at_cost_retail_description,at_cost_retail_internal_note";
